import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ApiService } from '../shared/services/api.service';
import { TranslatePipe } from '../shared/i18n/translate.pipe';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './contact.html',
  styleUrls: ['./contact.scss']
})
export class ContactComponent {
  private readonly api = inject(ApiService);
  readonly sending = signal(false);
  readonly success = signal(false);
  readonly error = signal('');
  model = { name: '', email: '', phone: '', subject: '', message: '', website: '' };

  submit(form: NgForm): void {
    if (form.invalid || this.sending()) return;
    this.sending.set(true);
    this.success.set(false);
    this.error.set('');
    this.api.submitContact(this.model).subscribe({
      next: () => {
        this.sending.set(false);
        this.success.set(true);
        form.resetForm({ name: '', email: '', phone: '', subject: '', message: '', website: '' });
      },
      error: err => {
        this.sending.set(false);
        this.error.set(err.error?.error || 'pages.contact.contact.error');
      }
    });
  }
}
